import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Discipline } from '@completion/models';
import { getDisciplines } from '@completion/selectors';
import { DisciplineLoad } from '@completion/actions';

export interface DisciplineSelectDialogData {
  title: string;
  /** Disciplines that already have templates — shown as info */
  existingDisciplines?: Discipline[];
}

@Component({
  selector: 'app-discipline-select-dialog',
  templateUrl: './discipline-select-dialog.component.html',
  styleUrls: ['./discipline-select-dialog.component.scss'],
  standalone: false,
})
export class DisciplineSelectDialogComponent implements OnInit, OnDestroy {
  disciplines$: Observable<Discipline[]>;
  selectedDiscipline: Discipline | null = null;
  existingDisciplines: Discipline[] = [];

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly store: Store,
    public dialogRef: MatDialogRef<DisciplineSelectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DisciplineSelectDialogData,
  ) {
    this.existingDisciplines = data.existingDisciplines || [];
    this.disciplines$ = this.store.pipe(select(getDisciplines), takeUntil(this.destroy$));
  }

  ngOnInit(): void {
    this.store.dispatch(new DisciplineLoad());
  }

  onConfirm(): void {
    if (this.selectedDiscipline) {
      this.dialogRef.close(this.selectedDiscipline);
    }
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
